import classNames from 'classnames/bind';
import React from 'react';

import { Image } from '@components/Image/Image';
import { Paragraph } from '@components/Paragraph/Paragraph';
import { datacampAddress } from '@siteData';

import styles from './OurOffices.module.scss';
import companyImage from './company.jpg';
import londonImage from './london.jpg';
import pragueImage from './prague.jpg';

const cx = classNames.bind(styles);

export const OurOffices: React.FC = () => (
  <div>
    <div className={cx('wrapper', 'shortCardsWrapper')}>
      <div className={styles.card}>
        <div className={styles.content}>
          <strong className={styles.title}>London</strong>
          <Paragraph className="mb-3" color="light" opacity={80}>
            {datacampAddress.street}
            <br />
            {datacampAddress.postalCode}, {datacampAddress.city}
            <br />
            {datacampAddress.country}
          </Paragraph>
        </div>
        <div className={styles.photoWrapper}>
          <Image alt="" className={styles.photo} height={375} src={londonImage} width={360} />
        </div>
      </div>

      <div className={styles.card}>
        <div className={styles.content}>
          <strong className={styles.title}>Prague</strong>
          <Paragraph className="mb-3" color="light" opacity={80}>
            Na Safrance 27
            <br />
            10100 Prague 10
            <br />
            Czech republic
          </Paragraph>
        </div>
        <div className={styles.photoWrapper}>
          <Image alt="" className={styles.photo} height={375} src={pragueImage} width={360} />
        </div>
      </div>
    </div>
    <div className={styles.wrapper}>
      <div className={cx('card', 'longCard')}>
        <div className={styles.content}>
          <strong className={styles.title}>Company info</strong>
          <div className={styles.companyTextsWrapper}>
            <Paragraph className={styles.taxRegNumbers} color="light" opacity={80}>
              DataCamp Limited
              <br />
              Company No. 07489096
              <br />
              VAT number: GB157027123
            </Paragraph>
            <Paragraph color="light" opacity={80}>
              {datacampAddress.street}
              <br />
              {datacampAddress.postalCode}, {datacampAddress.city}
              <br />
              {datacampAddress.country}
            </Paragraph>
          </div>
        </div>
        <div className={styles.photoWrapper}>
          <Image
            alt=""
            className={cx('photo', 'companyPhoto')}
            height={1454}
            src={companyImage}
            width={1454}
          />
        </div>
      </div>
    </div>
  </div>
);
